export const primary = '#004225';
export const primaryDark = '#0b3d39';
export const primaryLowOpacity = '#00422514';
export const accent1 = '#c49636';
export const accent1LowOpacity = '#c496360d';
export const accent2 = '#031b68';
export const accent2LowOpacity = '#031b680d';
export const accent3 = '#8e328f';
export const white = '#fff';
export const white2 = '#e7e7e7';
export const neutral1 = '#ffffff';
export const neutral2 = '#fafafa';
export const neutral3 = '#dddddd';
export const neutral4 = '#cacaca';
export const neutral5 = '#a6a6a6';
export const neutral6 = '#909090';
export const neutral6_5 = '#717171';
export const neutral7 = '#212121';
export const black = '#000';
export const black2 = '#212121';
export const gray = '#e0e0e0';
export const gray2 = '#fbfbfb';
export const gray3 = '#333333';
export const error = '#f05656';
export const warning = '#fcd853';
export const success = '#89cdbb';
export const errorDark = '#e43b3b';
export const warningDark = '#f7bd43';
export const successDark = '#004225';
export const errorMedium = '#ff8769';
export const warningMedium = '#ffcd73';
export const successMedium = '#89d7be';
export const errorLighter = '#e43b3b1a';
export const warningLighter = '#f7bd431a';
export const successLighter = '#0042251a';
export const errorLight = '#e43b3b0d';
export const warningLight = '#f7bd430d';
export const successLight = '#0042250d';
export const accordionBg = '#eaf5f1';
export const cooling = '#75b5b9';
export const coolingLight = '#bddfe1';
export const textDark = '#212121';
export const textLight = '#6e6e6e';
export const coralRed = '#e87053';
export const coralRedLight = '#f4ab9a';
export const aquaBlue = '#75b5b9';
export const aquaBlueLight = '#aacfd0';
export const moderate = 'rgba(255, 255, 0, 1)';
export const critical = 'rgba(200, 0, 0, 1)';
export const moderateBackground = 'rgba(255, 255, 244, 1)';
export const criticalBackground = 'rgba(255, 231, 226, 1)';
export const iconSize = '60px';
export const brightGreen = '#00C853'; // Material Design green A700
export const lightGreen = '#B9F6CA'; // Material Design green A100
export const inputLabels = '0.85rem';
export const instructions = '0.85rem';
export const primaryFontFamily = 'Inter, sans-serif';
